import React from 'react';

var Vimeo = function Vimeo(_ref) {
  var codigo = _ref.codigo;
  return React.createElement("iframe", {
    lang: "pt-br",
    title: "aula-preview",
    src: "https://player.vimeo.com/video/" + codigo,
    width: "100%",
    height: "100%",
    frameborder: "0",
    webkitallowfullscreen: true,
    mozallowfullscreen: true,
    allowfullscreen: true
  });
};

export default Vimeo;